import { render, staticRenderFns } from "./DetailProduitsHorsMarche.vue?vue&type=template&id=8a9b7356&"
import script from "./DetailProduitsHorsMarche.vue?vue&type=script&lang=js&"
export * from "./DetailProduitsHorsMarche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a9b7356')) {
      api.createRecord('8a9b7356', component.options)
    } else {
      api.reload('8a9b7356', component.options)
    }
    module.hot.accept("./DetailProduitsHorsMarche.vue?vue&type=template&id=8a9b7356&", function () {
      api.rerender('8a9b7356', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Commandes/DetailProduitsHorsMarche.vue"
export default component.exports